import { BreadcrumbsKey } from 'components/page/i18n/TModules';

export const translations = {
  [BreadcrumbsKey]: {
    Home: 'Startseite',
    Campaigns: 'Kampagnen',
    Customers: 'Kunden',
    List: 'Liste',
    LanguageSelector: 'Sprachauswahl',
    Preference: 'Einstellungen',
    Rewards: 'Prämien',
    LevelUpMarketing: 'Marketing-Steigerung',
    Info: 'Info',
    Audience: 'Zielgruppe',
    Mechanics: 'Mechanik',
    Review: 'Überprüfen',
    RewardInfo: 'Prämieninformationen',
    RewardMechanics: 'Prämienmechanik',
    SelectAudience: 'Zielgruppe auswählen'
  }
};
